import { Injectable } from '@angular/core';
import {
    HttpRequest,
    HttpHandler,
    HttpEvent,
    HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';

import { AppFacadeService } from '@services/app-facade.service';

/**
 * Handles user activity on the app.
 * Every time the user performs an action
 * that implies an API petition then the
 * interceptor updates last activty time.
 */
@Injectable({
    providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {
    /**
     * HeaderInterceptor Constructor
     * @param appFacadeService The Facade service of the app to set last time active in the app.
     */
    constructor(
        private appFacadeService: AppFacadeService,
    ) { }

        /**
     * This method evaluates if the request url includes or not 
     * version.json petition. If it doesn't then the last time 
     * activity is set
     * @param request
     * @param next 
     */
    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if(!request.url.includes('version.json')){
            this.appFacadeService.setLastTimeActive()
        }
        return next.handle(request)
    }
}